import { CIcon } from '~/icons/types'

export const ciJobs: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm21.994 18.246-3.311-4.314a6.483 6.483 0 0 0-8.129-9.88A3.741 3.741 0 1 0 5.253 9.3a4.193 4.193 0 0 0-3.567 4.134v6.108a1.74 1.74 0 0 0 1.738 1.738h8.569a1.74 1.74 0 0 0 1.737-1.738v-3.374h.058a6.46 6.46 0 0 0 2.491-.5l3.042 4.514a1.65 1.65 0 0 0 2.326.392 1.651 1.651 0 0 0 .347-2.333v.005ZM4.951 6.478a2.748 2.748 0 0 1 4.777-1.863A6.481 6.481 0 0 0 7.317 9.2a2.753 2.753 0 0 1-2.366-2.722Zm5.515 0a2.758 2.758 0 0 1-2.147 2.684 5.483 5.483 0 0 1 1.948-3.7c.13.323.198.668.199 1.016Zm2.264 8.59a5.507 5.507 0 0 1-4.409-4.832h1.211a3.2 3.2 0 0 1 3.2 3.2l-.002 1.631Zm0 4.474a.738.738 0 0 1-.737.738H3.424a.739.739 0 0 1-.738-.738v-6.108a3.2 3.2 0 0 1 3.2-3.2h1.435a6.5 6.5 0 0 0 5.409 5.841v3.467Zm1-4.374v-1.734A4.192 4.192 0 0 0 10.164 9.3a3.688 3.688 0 0 0 .936-4.412 5.493 5.493 0 1 1 2.687 10.283l-.057-.003Zm7.313 4.583a.654.654 0 0 1-.9-.135l-2.969-4.407a6.48 6.48 0 0 0 .794-.567l3.225 4.2a.652.652 0 0 1-.15.91Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'jobs',
  type: 'thin'
}
